import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import tabletKitchenSystem from '../assets/products/tablet-kitchen-system.png';
import tabletEatec2 from '../assets/products/tablet-eatec-2.png';

const KitchenPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page kitchenPage">
      <Header />
      <div className="page-header">On Site Dining</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Kitchen</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Whether diners place their orders via the POS, a self-service kiosk, their desktop or mobile phones, all orders are routed to the kitchen and managed using the IG Kitchen Display System to ensure quick and accurate order delivery, with Eatec inventory ensuring every ingredient is fresh and on-hand."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="IG KDS"
          imgSrc={tabletKitchenSystem}
          onClick={() => navigate('/solutions/ig-kds')}
        />
        <FeaturedItem
          label="Eatec"
          imgSrc={tabletEatec2}
          onClick={() => navigate('/solutions/eatec')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default KitchenPage;
